// ./Pages/LoginPage/LoginPage.js
import React, { useState, useContext } from "react";
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { setAuthToken } from "../../utils";
import { login, getMe } from "../../WebApi";
import { AuthContext } from "../../contexts";

const Root = styled.div`
  width: 400px;
  margin: 10px auto;
  border: 1px solid black;
  padding: 10px;
`;

const UserName = styled.div`
  margin-bottom: 10px;
  input {
    width: 320px;
  }
`;
const Password = styled.div`
  margin-bottom: 10px;
  input {
    width: 320px;
  }
`;

const ErrorMessage = styled.div`
  color: red;
`;

export default function LoginPage() {
  const {setUser} = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const history = useHistory(); 


  const handleSubmit = e => {
    e.preventDefault();
    login(username, password).then( data => {
      if (data.ok === 0) {
        return setErrorMessage(data.message);
      }
      setAuthToken(data.token);
      setErrorMessage('');

      getMe().then(resp => {
        if (resp.ok !==1) {
          setAuthToken(null);
          return setErrorMessage(resp.toString());
        }
        setUser(resp.data);
        history.push('/');
      });
    });
  };

  return (
    <Root>
      <form onSubmit={handleSubmit}>
        <UserName>
          username: <input type="text" value={username} onChange={ e => setUsername(e.target.value)} />
        </UserName>
        <Password>
          password: <input type="password" value={password} onChange={ e => setPassword(e.target.value)} />
        </Password>
        <button type="submit">登入</button>
        { errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </form>
    </Root>
  );
};